import React from "react";
import PropTypes from "prop-types";
import "./InfinityTunnelLoader.scss";


const Spinner = ({ text = "Hotel Air", isSpinner = false }) => {
  return (
    <>
      {isSpinner ? (
        <div className="loader-overlay">
          <div className="dancing-dots">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        </div>
      ) : (
        <div className="hotel-air-container">
          <h1 className="hotel-air-text">
            {text.split("").map((ch, i) => (
              <span key={i} style={{ animationDelay: `${i * 0.1}s` }}>
                {ch}
              </span>
            ))}
          </h1>
        </div>
      )}
    </>
  );
};

Spinner.propTypes = {
  text: PropTypes.string,
  isSpinner: PropTypes.bool,
};

export default Spinner;



export const InfinityTunnelLoader = () => {
  const frames = Array.from({ length: 18 });

  return (
    <div className="tunnel-loader">
      <div className="tunnel-bg"></div>

      <div className="tunnel">
        {frames.map((_, index) => (
          <span
            key={index}
            className="frame"
            style={{
              animationDelay: `${index * 0.15}s`,
            }}
          />
        ))}
      </div>

      <div className="loader-text">
        Preparing Experience
      </div>
    </div>
  );
};

